// Tailwind uses breakpoints in a mobile first style (unlike css)
// breakpoints define the lower limit of the size of a device
// and are used to specify tailwind classes that should be applied to
// screens larger than that breakpoint

// https://blisk.io/devices
export const BREAKPOINTS = {
  TABLET: 480, // iphone 16 pro max is 440px
  WIDE_TABLET: 769, // ipad mini is 768px
  LAPTOP: 1025, // ipad pro 12 is 1024px
  LARGE_LAPTOP: 1440, // 14" macbook pro is 1440px
  DESKTOP: 1729, // 16" macbook pro is 1728
} as const;
